/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([], function () {
    
    // returns the origin (protocol + host + port)
    var getOriginFromDataSource = function(dataSource) {
      if (!dataSource) return dataSource;

      var match = dataSource.match(/^(http(?:s)?\:)?(\/\/[^\/]+)/im),
          origin;

      if (!match) {
        throw Error('"' + dataSource + '" is not a valid URL');
      }

      return (match[1] || window.location.protocol) + match[2];
    };

    function urlContains(partialURL, fullURL) {
      return fullURL.indexOf(partialURL) !== -1;
    }

    function getQueryParam(url, name) {
      var match = RegExp('[?&]' + name + '=([^&]*)').exec(url);
      return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    function removeQueryParams(uri) {
      return uri.replace(/(\?.*)|(#.*)/g, '');
    }

   /**
    * Extract words from a text
	  *  @param {number} count number of words to extract
	  *  @param {string} text the text
	  *  @param {boolean} lastWords whether the extraction to start from the end of the string
	  *  @returns {string}
	 */
    function extractWordsFromText(count, text, startFromEnd) {
      var words = text.split(' ');
      //  If text contains less words then the required count return all the words
      if (words.length <= count) {
        return text;
      }
    
      if (startFromEnd) {
        // Word extraction should start from the end of the string  
        var startIndex = words.length - count;
        return words.slice(startIndex).join(' ');
      }
    
      return words.slice(0, count).join(' ');
    }

    function encodeURIComponentWithSpecialChars(string) {
      return encodeURIComponent(string)
        .replace(/\-/g, '%2D')
        .replace(/\_/g, '%5F')
        .replace(/\./g, '%2E')
        .replace(/\!/g, '%21')
        .replace(/\~/g, '%7E')
        .replace(/\*/g, '%2A')
        .replace(/\'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/–/g, '%E2%80%93');
    }

    function makeTextFragmentHashLink(string) {
      var highlightText = string.replace(/[\r\n\t]/gm, ',');
      var encodedText;
      // If text contains commas, use first part and last part to hightlight the whole text between. e.g #:~:text=<first word>,<last word>      
      var splitByCommas = highlightText.split(',');
      if (splitByCommas.length > 1) {
        // Limit the start and end text to 5 words range
        var startText = extractWordsFromText(5, splitByCommas[0]);
        var endText = extractWordsFromText(5, splitByCommas[splitByCommas.length - 1], true);
        
        encodedText = encodeURIComponentWithSpecialChars(startText) + ',' + encodeURIComponentWithSpecialChars(endText);
      } else {
        // Use character count instead of word count for more reliable length check
        if (highlightText.length > 100) { // Only split if text is longer than 100 characters
          var startText = extractWordsFromText(5, highlightText);
          var endText = extractWordsFromText(5, highlightText, true);
          encodedText = encodeURIComponentWithSpecialChars(startText) + ',' + encodeURIComponentWithSpecialChars(endText);
        } else {
          encodedText = encodeURIComponentWithSpecialChars(highlightText);
        }
      }
    
      var hashLink = "#:~:text=" + encodedText;

      return hashLink;
    }

    return {
      isRelative: function (channelUrl) {
        return !/^https?:\/\//.test(channelUrl);
      },

      directory: function (url) {
        return url.replace(/\/[^\/]*$/, "/")
      },

      getOriginFromDataSource: getOriginFromDataSource,

      sameOrigin: function (dataSource1, dataSource2) {
        var origin1 = getOriginFromDataSource(dataSource1),
            origin2 = getOriginFromDataSource(dataSource2);

        return origin1 === origin2;
      },
      urlContains: urlContains,
      removeQueryParams: removeQueryParams,
      getQueryParam: getQueryParam,
      makeTextFragmentHashLink: makeTextFragmentHashLink
    };
});
